import css from 'styled-jsx/css';

const styles = css.global`#renegociacao-consultar {
  background-image: linear-gradient(
    180deg,
    rgba(255, 255, 255, 1) 25%,
    rgba(255, 255, 255, 1) 37%,
    rgba(204, 0, 0, 1) 37%
  );
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 40px 0;
  overflow: hidden;
}

#renegociacao-consultar .ctn {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 55px;
}

.renegociacao-consultar-title {
  width: 220px;
  font-family: 'SantanderHeadline';
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  margin: 0;
  color: #444444;
}

.renegociacao-consultar-mobile {
  width: 288px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#renegociacao-consultar .renegociacao-consultar-mobile .custom-carousel .embla__container {
  gap: 16px;
}

#renegociacao-consultar .renegociacao-consultar-mobile .home-pagination .bullet {
  width: 4px !important;
  height: 4px !important;
  background-color: white;
}

#renegociacao-consultar .renegociacao-consultar-mobile .home-pagination .bullet.active {
  width: 8px !important;
  height: 8px !important;
  background-color: white;
}

.renegociacao-consultar-card a{
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.renegociacao-consultar-card:hover {
  transform: scale(1.015);
  transition: 0.1s linear;
}

.renegociacao-consultar-card-img {
  width: 288px;
  height: 215px;
  object-fit: cover;
  border-radius: 4px;
}

.renegociacao-consultar-card-type {
  font-family: 'SantanderMicroText';
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: white;
}

.renegociacao-consultar-card-title {
  font-family: 'SantanderText';
  font-size: 24px;
  line-height: 35px;
  letter-spacing: 0em;
  text-align: left;
  color: white;
  height: 100px;
}

.renegociacao-consultar-card-btn {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  text-decoration: underline;
  color: white;
}

.renegociacao-consultar-desktop {
  display: none;
}

@media (min-width: 576px) {
  #renegociacao-consultar {
    background-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 35%,
      rgba(255, 255, 255, 1) 24%,
      rgba(204, 0, 0, 1) 24%
    );
  }

  .renegociacao-consultar-title {
    width: 600px;
    font-family: 'SantanderHeadline';
    font-size: 28px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0em;
    text-align: left;
    margin: 0;
    color: #444444;
  }
}

@media (min-width: 992px) {
  #renegociacao-consultar {
    background-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 29%,
      rgba(255, 255, 255, 1) 40%,
      rgba(204, 0, 0, 1) 40%
    );
  }

  #renegociacao-consultar .ctn {
    max-width: 1310px;
    gap: 30px;
  }

  .renegociacao-consultar-title {
    width: 100%;
    font-family: 'SantanderHeadline';
    font-size: 32px;
    font-weight: 400;
    line-height: 46px;
    text-align: center;
  }

  .renegociacao-consultar-mobile {
    display: none;
  }

  .renegociacao-consultar-desktop {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    gap: 16px;
  }

  .renegociacao-consultar-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 384px;
    width: 100%;
    z-index: 1;
  }

  .renegociacao-consultar-card-img {
    max-width: 384px;
    width: 100%;
    max-height: 215px;
    min-height: 215px;
    height: 100%;
  }

  .renegociacao-consultar-card-type {
    font-family: 'SantanderMicroText';
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    color: white;
  }

  .renegociacao-consultar-card-title {
    font-family: 'SantanderText';
    font-size: 24px;
    font-weight: 400;
    line-height: 35px;
    letter-spacing: 0em;
    text-align: left;
    color: white;
    height: 70px;
  }

  .renegociacao-consultar-card-btn {
    font-family: 'SantanderText';
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: left;
    text-decoration: underline;
    color: white;
  }

  .renegociacao-consultar-circles {
    position: absolute;
    right: -120px;
    bottom: 0;
  }
}
`;

export default styles;